import Vue from "vue";
import Vuetify from 'vuetify';
import * as types from '../../store/types';
import {store} from '../../store/store';

const notify = (text, options) => {
   store.dispatch(types.SHOW_NOTIFICATION, {text, options} )
}

Vue.prototype.$notify = (text, options) => {
   if(!options){
      options = {}
   }
   if(!options.position){      
      options.position = "bottom"
   }
   notify(text, options);
};
